// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import Mali from '../_raw/flag/icon_flag_mali.png';

export default () => <img src={Mali} alt="Mali" />;
